import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '@scripts/woo_services.module/AuthService';
import { Feedback, FeedbackService } from '@scripts/woo_services.module/FeedbackService';
import { GoogleTagManagerService } from '@scripts/woo_services.module/GoogleTagManagerService';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-feedback-modal',
  imports: [ModalLayoutComponent, CommonModule, RouterLink, FormsModule],
  templateUrl: './feedback-modal.component.html',
  styleUrl: './feedback-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackModalComponent extends BaseModalComponent<{ feedbackSent: boolean; supportPhone: string }> {
  private authService = inject(AuthService);
  private feedbackService = inject(FeedbackService);
  private googleTagManagerService = inject(GoogleTagManagerService);
  status = this.modaldata;
  feedbackSent = signal(false);
  name = signal('');
  email = signal('');
  problemDescription = signal('');
  problemArea = signal('');
  expectedOutcome = signal('');
  actualOutcome = signal('');
  feedback = computed(() => ({
    name: this.name(),
    email: this.email(),
    problem_description: this.problemDescription(),
    problem_area: this.problemArea(),
    expected_outcome: this.expectedOutcome(),
    actual_outcome: this.actualOutcome(),
  }));

  supportPhone = this.feedbackService.supportPhone;
  isLoggedIn = this.authService.isAuthenticatedSignal();

  sendFeedback = (feedback: Feedback): void => {
    this.googleTagManagerService.sendSupport();
    this.feedbackService.sendFeedback(feedback).then(() => {
      this.feedbackSent.set(true);
    });
  };
}
